import WorkLogForm from "../workLogForm";
//---------------------------------------------------
export default function GPRForm({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Address/Location", type: "text", required: true}, 
        {title: "Cancel", type:"radio", default: "No", required: true}, 
        {title: "Coordniates", type: "latlng", parentNo: "Cancel"}, 
        {title: "Notes", type: "textarea", required: true} 
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            picsLimit = {6}
            items = {items}
            {...rest}
        />
    )    
}